import axios from "axios";

export const userService = {
  getFundraisersService: (params) =>
    axios.get("/user", { auth: true, params: params }),

  editUserService: (id, body) =>
    axios.patch(`/user/${id}`, body, { auth: true }),
};
